import CONFIGS from "build/Config";

const SolMezclasGame = () => {
  return (
    <a href={CONFIGS.play_endpoint} target="_blank" rel="noopener noreferrer" className="button-home">
      <img src={`${AZURE_BASE_URL}/button-game.webp`} className='w-full' />
    </a>
  )
}

export default SolMezclasGame